// extracted by mini-css-extract-plugin
export default {"reactMarkDown":"page-style_reactMarkDown__ppBAH"};